import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Marketing = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.953 6.22a4.341 4.341 0 0 1 8.435 1.44v7.531c3.173.476 5.612 3.218 5.612 6.52 0 3.304-2.44 6.046-5.612 6.522v4.831a4.34 4.34 0 0 1-8.434 1.44l-5.303-3.995c-3.88-2.923-8.303-4.548-12.825-4.737V40.68H4.077V25.592A5.4 5.4 0 0 1 0 20.349a5.395 5.395 0 0 1 5.392-5.404h6.496v.004c4.5-.201 8.9-1.825 12.763-4.734l5.302-3.995Zm6.469 1.44v25.404a2.373 2.373 0 0 1-4.746 0V7.66a2.373 2.373 0 0 1 4.746 0Zm-6.713 1.13v23.143l-3.914-2.95c-4.174-3.143-8.97-4.915-13.907-5.117v-7.008c4.936-.202 9.733-1.975 13.907-5.119l3.914-2.949Zm8.68 17.444a4.637 4.637 0 0 0 3.644-4.522 4.637 4.637 0 0 0-3.645-4.522v9.044ZM5.391 16.852a3.49 3.49 0 0 0-3.489 3.497 3.49 3.49 0 0 0 3.49 3.497h4.592v-6.994H5.392Zm4.467 9.409H6.044v12.453H9.86V26.261Z"
  }));
});
Marketing.displayName = 'Marketing';
Marketing.defaultProps = {
  'aria-label': 'Marketing'
};
export default Marketing;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/Marketing.js
// module id = 3038
// module chunks = 11